import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {PRICES_CITIES_SLUGS} from "@pg-rp/navigation";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";

export const validatePriceReportRegion = (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch) => {
    const {regionSlug} = ctx.match.params;

    if (PRICES_CITIES_SLUGS.includes(regionSlug)) {
        return true;
    }

    dispatch(rpEnable404ResponseState(ctx.route.pathname));

    return false;
};
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {PRICES_CITIES_SLUGS} from "@pg-rp/navigation";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";

export const validatePriceReportRegion = (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch) => {
    const {regionSlug} = ctx.match.params;

    if (PRICES_CITIES_SLUGS.includes(regionSlug)) {
        return true;
    }

    dispatch(rpEnable404ResponseState(ctx.route.pathname));

    return false;
};
